import React from 'react'

interface FileUploadIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const FileUploadIcon: React.FC<FileUploadIconProps> = ({
  color = '#000',
  gradient,
  width = 18,
  height = 24,
  alt = 'Upload icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 18 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        stroke={gradient ? 'url(#grad1)' : color}
        strokeWidth='1.25'
        d='M.625 2C.625 1.24 1.241.625 2 .625h8.26c.328 0 .646.117.895.331l5.74 4.92c.305.261.48.642.48 1.044V22c0 .76-.616 1.375-1.375 1.375H2c-.76 0-1.375-.616-1.375-1.375V2z'
      />
      <mask id='path-2-inside-1_1972_477' fill='#fff'>
        <path
          fillRule='evenodd'
          d='M17.622 5.75H12a.75.75 0 01-.75-.75V.262A2 2 0 0010.26 0H10v5a2 2 0 002 2h6v-.08a2 2 0 00-.378-1.17z'
          clipRule='evenodd'
        />
      </mask>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        d='M17.622 5.75l1.014-.731-.374-.519h-.64v1.25zM11.25.262h1.25v-.726l-.631-.36L11.25.262zM10 0v-1.25H8.75V0H10zm8 7v1.25h1.25V7H18zm-6 0h5.622V4.5H12V7zm-2-2a2 2 0 002 2V4.5a.5.5 0 01.5.5H10zm0-4.738V5h2.5V.262H10zm.26.988a.75.75 0 01.371.098L11.87-.824a3.25 3.25 0 00-1.609-.426v2.5zm-.26 0h.26v-2.5H10v2.5zM8.75 0v5h2.5V0h-2.5zm0 5A3.25 3.25 0 0012 8.25v-2.5a.75.75 0 01-.75-.75h-2.5zM12 8.25h6v-2.5h-6v2.5zm4.75-1.33V7h2.5v-.08h-2.5zm-.142-.439a.75.75 0 01.142.439h2.5a3.25 3.25 0 00-.614-1.901L16.608 6.48z'
        mask='url(#path-2-inside-1_1972_477)'
      />
      <path
        stroke={gradient ? 'url(#grad1)' : color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
        d='M6 12l3-3 3 3M9 9.5V17M5 17.5v2h8v-2'
      />
    </svg>
  )
}

export default FileUploadIcon
